package org.example.project.service

import androidx.compose.runtime.mutableStateMapOf
import org.example.project.utils.All

object SnapPopupService {

    private val popupsByNode = mutableStateMapOf<String, List<All>>()

    fun getPopups(node: String): List<All> = popupsByNode[node] ?: emptyList()

    fun replacePopups(node: String, popups: List<All>) {
        if (node.isBlank()) return
        popupsByNode[node] = popups.distinctBy { it.id }
    }

    fun closePopup(node: String, id: String) {
        popupsByNode[node] = (popupsByNode[node] ?: emptyList()).filterNot { it.id == id }
    }
}
